import disaster from './disaster'
import station from './fire-station'
import airport from './airport'
import map from './map'

let STATE = {PAUSE: 0, PLAY: 1};
let meta = {
  cost: 0,
  state: STATE.PAUSE,
  elapse: 0,
  scheme: {},
};

export default {
  STATE,
  // models
  disaster,
  station,
  airport,
  map,
  // metainfo
  meta,
  survival: 0,
  danger: 0,
  logs: [],
  history: {
    timeline: [],
    firePower: [],
    fireGrowth: [],
    engineState: [],
    engineCapacity: [],
    aircraftDurability: [],
  },
  // functions
  reset: function () {
    disaster.reset();
    station.reset();
    airport.reset();
    map.reset();
    this.logs.splice(0);
    _.values(this.history).forEach(records => records.splice(0));

    meta.cost = 0;
    meta.state = STATE.PAUSE;
    meta.elapse = 0;
    meta.scheme = this.randomScheme();
  },
  record: function () {
    if (this.history.firePower.length === 0) {
      this.history.firePower.push(...disaster.disasters.map(disaster => ({
        type: 'line',
        name: disaster.target,
        data: [],
        markLine: {data: []}
      })));
      this.history.fireGrowth.push(...disaster.disasters.map(disaster => ({
        type: 'line',
        name: disaster.target,
        data: []
      })));
      this.history.engineState.push(..._.map(station.engine.STATE, (v) => ({
        type: 'line',
        name: station.engine.stateNames[v],
        value: v,
        data: [],
        markLine: {data: []}
      })));
      this.history.engineCapacity.push(...station.engine.types.map(type => ({
        type: 'line',
        name: type.type,
        data: []
      })));
      this.history.aircraftDurability.push(...airport.aircraft.aircrafts.map(aircraft => ({
        type: 'line',
        name: aircraft.name,
        data: []
      })));
    }
    this.history.firePower.forEach(record => {
      record.data.push(disaster.disasters.find(disaster => disaster.target === record.name).power)
    });
    this.history.fireGrowth.forEach(record => {
      let instance = disaster.disasters.find(disaster => disaster.target === record.name);
      record.data.push(instance.trend)
    });
    this.history.engineState.forEach(record => {
      record.data.push(station.engine.engines.filter(engine => engine.state === record.value).length)
    });
    this.history.engineCapacity.forEach(record => {
      record.data.push(_.reduce(station.engine.engines.filter(engine => engine.type === record.name), (r, v) => r + v.capacity, 0))
    });
    this.history.aircraftDurability.forEach(record => {
      record.data.push(airport.aircraft.aircrafts.find(aircraft => aircraft.name === record.name).durability)
    });
    this.history.timeline.push(this.history.timeline.length);
  },
  tick: function () {
    let simulator = this;
    if (meta.elapse === 0) {
      this.survival = airport.aircraft.aircrafts.length;
      this.danger = airport.aircraft.aircrafts.length;

      station.engine.types.forEach(engineType => {
        for (let i = 0; i < engineType.amount; i++) {
          let stationLocation = map.get(station.name);
          map.set(station.engine.buildInstance(engineType.type), stationLocation.x, stationLocation.y)
        }
      });

      simulator.record();

      // 最长准备时间
      let maxPrepareTime = Math.max(...station.engine.types.map(type => type.prepare));
      // 最低行驶速度
      let lowestSpeed = Math.min(...station.engine.types.map(type => type.speed));
      let highestFlow = Math.max(...station.engine.types.map(type => type.flow));
      let lowestCapacity = Math.min(...station.engine.types.map(type => type.capacity));
      // 计算初始数据
      let aircrafts = airport.aircraft.aircrafts.map(function (aircraft) {
        let distance = map.distance(aircraft, station);
        let disaster = simulator.disaster.disasters.find(disaster => disaster.target === aircraft.name);
        simulator.logs.push({
          message: '[' + aircraft.name + ']处发现火情，火势[' + disaster.power + ']，蔓延[' + disaster.growth + ']',
          level: 'error',
          time: meta.elapse
        });
        // 最长前置时间
        let maxLeadTime = maxPrepareTime + distance / lowestSpeed;
        // 极限最大火势
        let maxFirePower = disaster.power + disaster.growth * maxLeadTime;
        // 最大前置伤害
        let maxLeadDamage = (disaster.power + maxFirePower) * maxLeadTime / 2;
        // 最长存活时间
        // let maxSurvivalTime = Math.floor((aircraft.durability - maxLeadDamage) * 2 / maxFirePower - 1);
        let maxSurvivalTime = Math.min(Math.floor((aircraft.durability - maxLeadDamage) * 2 / maxFirePower - 1), Math.floor(lowestCapacity / highestFlow));
        // 最低救援流量
        let minFlow = maxFirePower / maxSurvivalTime;
        // 最低救援储量
        let minCapacity = maxFirePower * maxSurvivalTime;
        // 分配方案
        let scheme = _.mapValues(station.engine.mappedTypes, () => 0);
        return {
          aircraft,
          distance,
          disaster,
          maxLeadTime,
          maxFirePower,
          maxSurvivalTime,
          minFlow,
          minCapacity,
          scheme,
          survive: false
        }
      });

      let sumFlow = scheme => _.reduce(scheme, (r, v, k) => r + station.engine.mappedTypes[k].flow * v, 0);
      let sumScheme = _.mapValues(station.engine.mappedTypes, () => 0);
      let sumCapacity = scheme => _.reduce(scheme, (r, v, k) => r + station.engine.mappedTypes[k].capacity * v, 0);

      aircrafts.forEach(aircraft => {
        let flowSum = sumFlow(aircraft.scheme);
        let capacitySum = sumCapacity(aircraft.scheme);

        // 初始分配
        station.engine.types.forEach(engineType => {
          while ((aircraft.minFlow > flowSum || aircraft.minCapacity > capacitySum) && aircraft.scheme[engineType.type] + sumScheme[engineType.type] < engineType.amount) {
            aircraft.scheme[engineType.type] += 1;
            flowSum += engineType.flow;
            capacitySum += engineType.capacity * 2;
          }
        });

        // 优化分配

        // 结算
        _.forEach(aircraft.scheme, (v, k) => sumScheme[k] += v);
        if (aircraft.minFlow < flowSum || aircraft.minCapacity < capacitySum) {
          aircraft.survive = true;
        }
      });

      // 派车
      aircrafts.forEach(aircraft => {
        simulator.logs.push({
          message: '以[' + aircraft.aircraft.name + ']为目标的救援单位开始出发前的准备',
          level: 'info',
          time: meta.elapse
        });
        _.forEach(aircraft.scheme, (v, k) => {
          station.engine.engines
            .filter(engine => engine.state !== station.engine.STATE.PREPARE)
            .filter(engine => engine.type === k)
            .slice(0, v)
            .forEach(engine => {
              engine.state = station.engine.STATE.PREPARE;
              engine.cruise.src = station.name;
              engine.cruise.dst = aircraft.aircraft.name;
            })
        })
      })
    }

    disaster.disasters.filter(instance => instance.power > 0).forEach(instance => instance.trend = instance.growth);

    // 救援
    station.engine.engines.filter(engine => engine.state === station.engine.STATE.WORK).forEach(engine => {
      let aircraft = airport.aircraft.aircrafts.find(aircraft => aircraft.name === engine.cruise.dst);
      let fire = disaster.fire.get(aircraft.name);

      if (fire.power > 0) {
        if (engine.capacity > 0) {
          if (0 === fire.input) {
            simulator.history.engineState.find(record => record.value === station.engine.STATE.WORK).markLine.data.push({
              name: '救援单位抵达\n[' + aircraft.name + ']\n并展开救援',
              xAxis: simulator.history.timeline.length,
              label: {formatter: '{b}'}
            });
            simulator.history.firePower.find(record => record.name === fire.target).markLine.data.push({
              name: '救援单位抵达\n[' + aircraft.name + ']\n并展开救援',
              xAxis: simulator.history.timeline.length,
              label: {formatter: '{b}'}
            });
            simulator.logs.push({
              message: '救援单位抵达[' + aircraft.name + ']并展开救援',
              level: 'warning',
              time: meta.elapse + 1
            });
          }

          let input = Math.min(fire.power, engine.capacity, engine.flow);
          fire.input += input;
          fire.trend -= input;
          fire.power -= input;
          engine.capacity -= input;

          if (fire.power === 0) {
            simulator.history.firePower.find(record => record.name === fire.target).markLine.data.push({
              name: '发生在[\n' + aircraft.name + '\n]的灾情被排除',
              xAxis: simulator.history.timeline.length,
              label: {formatter: '{b}'}
            });
            let aircraftType = airport.aircraft.mappedTypes[aircraft.type];
            simulator.logs.push({
              message: '发生在[' + aircraft.name + ']的灾情被排除，持续[' + fire.elapse + ']，造成损失[' + (aircraftType.durability - aircraft.durability) + ']',
              level: 'success',
              time: meta.elapse + 1
            })
          }
        }
        if (fire.power === 0 || engine.capacity === 0) {
          engine.state = station.engine.STATE.STANDBY;
        }
      }
    });

    // 调度
    station.engine.engines.filter(engine => engine.state === station.engine.STATE.CRUISE).forEach(function (engine) {
      let src = map.get(engine.name);
      let dst = map.get(engine.cruise.dst);

      if (map.distance(engine, engine.cruise.dst) > engine.speed) {
        map.get(engine.name).x += (dst.x - src.x) * engine.speed / map.distance(engine, engine.cruise.dst);
        map.get(engine.name).y += (dst.y - src.y) * engine.speed / map.distance(engine, engine.cruise.dst);
      } else {
        if (!dst || !src) {
          console.log(engine.name)
        }
        src.x = dst.x;
        src.y = dst.y;
        engine.state = station.engine.STATE.WORK;
      }
    });

    // 准备
    let preparingEngines = station.engine.engines.filter(engine => engine.state === station.engine.STATE.PREPARE);
    preparingEngines.filter(engine => engine.elapsed < engine.prepare).forEach(engine => {
      engine.elapsed += 1;
    });
    let preparedEngine = preparingEngines.find(engine => engine.elapsed === engine.prepare);
    if (preparedEngine) {
      if (!station.engine.engines.find(engine => engine.state === station.engine.STATE.CRUISE)) {
        simulator.history.engineState.find(record => record.value === station.engine.STATE.CRUISE).markLine.data.push({
          name: '救援单位陆续出动',
          xAxis: simulator.history.timeline.length,
          label: {formatter: '{b}'}
        });
        simulator.logs.push({
          message: '救援单位陆续出动',
          level: 'success',
          time: meta.elapse + 1
        })
      }
      preparedEngine.state = station.engine.STATE.CRUISE;
      preparedEngine.elapsed = 0;
    }

    // 蔓延
    disaster.disasters.filter(fire => fire.power > 0).forEach(function (fire) {
      let aircraft = airport.aircraft.aircrafts.find(a => a.name === fire.target);
      if (aircraft.durability > 0) {
        fire.power += fire.growth
      }
    });

    // 伤害
    let survival = airport.aircraft.aircrafts.length;
    let danger = airport.aircraft.aircrafts.length;

    airport.aircraft.aircrafts.forEach(function (aircraft) {
      let fire = disaster.disasters.find(d => d.target === aircraft.name);
      if (fire && fire.power > 0) {
        fire.elapse += 1;
        aircraft.durability = Math.max(aircraft.durability - fire.power, 0);
      }

      if (aircraft.durability === 0) {
        survival -= 1;
        danger -= 1;
        simulator.logs.push({
          message: '[' + aircraft.name + ']在坚持了[' + (meta.elapse + 1) + ']后化为灰烬',
          level: 'error',
          time: meta.elapse + 1
        });
      } else if (!fire || fire.power === 0) {
        danger -= 1;
      }
    });

    this.survival = survival;
    this.danger = danger;

    meta.elapse += 1;
    this.record();
    simulator.logs.splice(0, simulator.logs.length - 10)
  },
  random: function (min, max) {
    return parseInt(Math.random() * (max - min) + min, 10)
  },
  randomScheme: function () {
    let simulator = this;

    // station
    map.set(station.name, 0, 1000);

    // engineTypes
    station.engine.setupType('Alex', 50, 5000, 30, 10, 500, 30);
    station.engine.setupType('Bob', 80, 12000, 20, 15, 1000, 30);

    // airCrafts
    airport.aircraft.setupType('B747', 500, 800000, 1);
    airport.aircraft.setupType('B737', 500, 500000, 1);

    // aircrafts & disasters
    airport.aircraft.types.forEach(function (type) {
      for (let i = 0; i < type.amount; i++) {
        simulator.buildAircraft(type.type);
      }
    });
  },
  copyAircraftType: function (typeName) {
    typeName = airport.aircraft.copyType(typeName)
    this.buildAircraft(typeName);
  },
  dropAircraftType: function (typeName) {
    airport.aircraft.aircrafts
      .filter(aircraft => aircraft.type === typeName)
      .forEach(aircraft => this.dropAircraft(aircraft.name));
    airport.aircraft.dropType(typeName)
  },
  buildAircraft: function (type) {
    let simulator = this;
    let name = airport.aircraft.buildInstance(type);
    map.set(name, simulator.random(200, 1000), simulator.random(200, 1000));
    disaster.fire.set(name, simulator.random(200, 1000), simulator.random(50, 200));
  },
  dropAircraft: function (name) {
    name = airport.aircraft.dropInstance(name).name;
    disaster.disasters.splice(disaster.disasters.findIndex(disaster => disaster.target === name), 1);
  }
}
